import React from "react";

export default function SearchIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0007 14L11.01 11.004L14.0007 14ZM12.6673 6.99998C12.6673 8.50287 12.0703 9.94421 11.0076 11.0069C9.94488 12.0696 8.50354 12.6666 7.00065 12.6666C5.49776 12.6666 4.05642 12.0696 2.99371 11.0069C1.93101 9.94421 1.33398 8.50287 1.33398 6.99998C1.33398 5.49709 1.93101 4.05575 2.99371 2.99304C4.05642 1.93034 5.49776 1.33331 7.00065 1.33331C8.50354 1.33331 9.94488 1.93034 11.0076 2.99304C12.0703 4.05575 12.6673 5.49709 12.6673 6.99998V6.99998Z"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
